export default {
	// actions
	actionsText: {
		view: "View",
		edit: "Edit",
		delete: "Delete",
		"*": "Actions"
	},

	// per page
	perPageText: "Show :entries entries",

	// entries info
	infoText: "Showing :first to :last of :total entries",
	infoTextFiltered:
		"Showing :first to :last of :filtered (filtered from :total entries)",

	// pagination
	nextButtonText: "Next",
	previousButtonText: "Previous",
	paginationSearchText: "Go to page",
	paginationSearchButtonText: "GO",

	// search filter
	searchText: "search:",
	emptyTableText: "No matching records found",

	// export
	downloadText: "export as:",
	downloadButtonText: "DOWNLOAD"
};
